import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archieve',
  templateUrl: './archieve.component.html',
  styleUrls: ['./archieve.component.scss']
})
export class ArchieveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
